import { Modal } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import "./AddProducts.css";
import { db } from "./Firebase";

const AddProducts = () => {
	const [title, setTitle] = useState("");
	const [price, setPrice] = useState("");
	const [rating, setRating] = useState("");
	const [image, setImage] = useState("");

	const addTodoHandler = (event) => {
		event.preventDefault();

		if (!title || !price || !rating || !image) return;

		const newProduct = {
			title: title,
			price: price,
			rating: rating,
			image: image,
		};

		db.collection("products").add(newProduct);

		setTitle("");
		setPrice("");
		setRating("");
		setImage("");

		setOpen(true);
	};

	const [open, setOpen] = useState(false);

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<div className="addProducts">
			<h1>Add a new Product</h1>
			<div className="App">
				<form className="addproduct__form">
					<input
						placeholder="Product Name/Title"
						value={title}
						onChange={(event) => setTitle(event.target.value)}
						className="input_box"
					></input>
					<input
						type="number"
						placeholder="Price"
						value={price}
						onChange={(event) => setPrice(event.target.value)}
						className="input_box"
					></input>
					<input
						type="number"
						placeholder="Rating"
						value={rating}
						onChange={(event) => setRating(event.target.value)}
						className="input_box"
					></input>
					<input
						placeholder="Image Link"
						value={image}
						onChange={(event) => setImage(event.target.value)}
						className="input_box"
					></input>

					<button
						type="submit"
						onClick={addTodoHandler}
						className="add_todo_button"
					>
						ADD
					</button>
				</form>
			</div>

			<Modal
				open={open}
				onClose={handleClose}
				className="product__modalContainer"
			>
				<h1 className="product__new">New Product Added 📦</h1>
			</Modal>
		</div>
	);
};

export default AddProducts;
